export enum RecipientTypes {
  CLIENT = 'CLIENT',
  CLIENT_CONTACT = 'CLIENT_CONTACT',
}
